import { Slot, SlotProps } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/app/common/common-functions/functions";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router";
import { forwardRef, ElementRef, HTMLProps } from "react";

const linkVariants = cva("hover:tw-no-underline tw-cursor-default", {
  variants: {
    variant: {
      unstyled: "",
      default: "tw-text-linkblue hover:tw-underline tw-cursor-pointer",
      bold: "tw-font-bold tw-text-linkblue hover:tw-underline tw-cursor-pointer",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

type BaseLinkProps = VariantProps<typeof linkVariants> & {
  className?: string;
  asChild?: boolean;
};

type LinkProps = BaseLinkProps & (({ asChild?: false } & RouterLinkProps) | ({ asChild: true } & SlotProps));

const Link = forwardRef<ElementRef<typeof RouterLink>, LinkProps>(({ className, variant, asChild, ...props }, ref) => {
  const classes = cn(linkVariants({ variant, className }));

  if (asChild) {
    return <Slot className={classes} ref={ref} {...props} />;
  }

  const routerProps = props as RouterLinkProps;
  return <RouterLink className={classes} ref={ref} {...routerProps} />;
});
Link.displayName = "Link";

export { Link, linkVariants };
